/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _solojazz = __webpack_require__(1);
	
	var _solojazz2 = _interopRequireDefault(_solojazz);
	
	var _header = __webpack_require__(7);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Site = {
	  init: function init() {
	    _solojazz2.default.init();
	    _header2.default.init();
	  }
	};
	
	Site.init();

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parallax = __webpack_require__(2);
	
	var _parallax2 = _interopRequireDefault(_parallax);
	
	var _smoothScroll = __webpack_require__(3);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	var _overunder = __webpack_require__(4);
	
	var _overunder2 = _interopRequireDefault(_overunder);
	
	var _styleselect = __webpack_require__(5);
	
	var _styleselect2 = _interopRequireDefault(_styleselect);
	
	var _lazyClass = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SoloJazz = {
	  // cache dom elements
	  dom: {
	    hero: document.querySelector('.js-hero'),
	    header: document.querySelector('.header'),
	    siteParalless: document.querySelector('.js-slow-jazz')
	  },
	  init: function init() {
	
	    this.smoothScrolling();
	    this.handleScrolling();
	    this.handleHeader(this.dom.hero);
	    (0, _styleselect2.default)('select');
	  },
	  handleHeader: function handleHeader(hero) {
	    var backgrounds = hero.querySelectorAll('.home--hero-backgrounds div'),
	        headlines = hero.querySelector('.js-headlines'),
	        down = hero.querySelector('.js-down'),
	        header = this.dom.header;
	
	    (0, _lazyClass.lazy)(headlines, 'loaded', 1000);
	    (0, _lazyClass.lazy)(backgrounds, 'loaded', 1200);
	    (0, _lazyClass.lazy)(down, 'loaded', 1300);
	    (0, _lazyClass.lazy)(backgrounds, 'size', 1350);
	    (0, _lazyClass.lazy)(header, 'loaded', 1400);
	  },
	  smoothScrolling: function smoothScrolling() {
	    var header = this.dom.header;
	    _smoothScroll2.default.init({
	      selector: '[data-scroll]', // Selector for links (must be a valid CSS selector)
	      selectorHeader: '[data-scroll-header]', // Selector for fixed headers (must be a valid CSS selector)
	      speed: 500, // Integer. How fast to complete the scroll in milliseconds
	      easing: 'easeInOutCubic', // Easing pattern to use
	      updateURL: true, // Boolean. Whether or not to update the URL with the anchor hash on scroll
	      offset: 40, // Integer. How far to offset the scrolling anchor location in pixels
	      callback: function callback(toggle, anchor) {
	        header.classList.remove('open');
	        setTimeout(function () {
	          header.classList.remove('opening');
	        }, 250);
	      } // Function to run after scrolling
	    });
	  },
	  handleScrolling: function handleScrolling() {
	
	    var productOne = document.querySelector('.js-product-one'),
	        productTwo = document.querySelector('.js-product-two'),
	        founder = document.querySelector('.js-founder');
	    var handleScrolling = function handleScrolling() {
	      _parallax2.default.init(productOne, -8, 300);
	      _parallax2.default.init(productTwo, -8, 300);
	      _parallax2.default.init(founder, -8, 100);
	    };
	
	    window.addEventListener('scroll', handleScrolling);
	  }
	};
	
	exports.default = SoloJazz;

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Parallax = {
	  init: function init(el, displace, direction) {
	    this.animateItem(el, displace, direction);
	  },
	  setPosition: function setPosition() {
	    if (window.pageYOffset !== undefined) {
	      return window.pageYOffset;
	    } else {
	      return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	    }
	  },
	  animateItem: function animateItem(el, displace, direction) {
	    // if (typeof window.orientation !== 'undefined') { return; }
	    var scrollPosition = this.setPosition();
	
	    if (direction === 'sideways') {
	      el.style.backgroundPosition = (800 + scrollPosition) / displace + "px center";
	    } else {
	      var value = scrollPosition / displace + direction;
	      el.style.transform = "translate3d(0px, " + value + "px, 0px)";
	    }
	  }
	};
	
	exports.default = Parallax;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! smooth-scroll v9.1.4 | (c) 2016 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
	!function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t(e)), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(e):e.smoothScroll=t(e)}("undefined"!=typeof global?global:this.window||this.global,function(e){"use strict";var t,n,r,o,a,c={},u="querySelector"in document&&"addEventListener"in e,i={selector:"[data-scroll]",selectorHeader:"[data-scroll-header]",speed:500,easing:"easeInOutCubic",offset:0,updateURL:!0,callback:function(){}},l=function(){var e={},t=!1,n=0,r=arguments.length;"[object Boolean]"===Object.prototype.toString.call(arguments[0])&&(t=arguments[0],n++);for(var o=function(n){for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t&&"[object Object]"===Object.prototype.toString.call(n[r])?e[r]=l(!0,e[r],n[r]):e[r]=n[r])};r>n;n++){var a=arguments[n];o(a)}return e},s=function(e){return Math.max(e.scrollHeight,e.offsetHeight,e.clientHeight)},f=function(e,t){var n,r,o=t.charAt(0),a="classList"in document.documentElement;for("["===o&&(t=t.substr(1,t.length-2),n=t.split("="),n.length>1&&(r=!0,n[1]=n[1].replace(/"/g,"").replace(/'/g,"")));e&&e!==document&&1===e.nodeType;e=e.parentNode){if("."===o)if(a){if(e.classList.contains(t.substr(1)))return e}else if(new RegExp("(^|\\s)"+t.substr(1)+"(\\s|$)").test(e.className))return e;if("#"===o&&e.id===t.substr(1))return e;if("["===o&&e.hasAttribute(n[0])){if(!r)return e;if(e.getAttribute(n[0])===n[1])return e}if(e.tagName.toLowerCase()===t)return e}return null};c.escapeCharacters=function(e){"#"===e.charAt(0)&&(e=e.substr(1));for(var t,n=String(e),r=n.length,o=-1,a="",c=n.charCodeAt(0);++o<r;){if(t=n.charCodeAt(o),0===t)throw new InvalidCharacterError("Invalid character: the input contains U+0000.");a+=t>=1&&31>=t||127==t||0===o&&t>=48&&57>=t||1===o&&t>=48&&57>=t&&45===c?"\\"+t.toString(16)+" ":t>=128||45===t||95===t||t>=48&&57>=t||t>=65&&90>=t||t>=97&&122>=t?n.charAt(o):"\\"+n.charAt(o)}return"#"+a};var d=function(e,t){var n;return"easeInQuad"===e&&(n=t*t),"easeOutQuad"===e&&(n=t*(2-t)),"easeInOutQuad"===e&&(n=.5>t?2*t*t:-1+(4-2*t)*t),"easeInCubic"===e&&(n=t*t*t),"easeOutCubic"===e&&(n=--t*t*t+1),"easeInOutCubic"===e&&(n=.5>t?4*t*t*t:(t-1)*(2*t-2)*(2*t-2)+1),"easeInQuart"===e&&(n=t*t*t*t),"easeOutQuart"===e&&(n=1- --t*t*t*t),"easeInOutQuart"===e&&(n=.5>t?8*t*t*t*t:1-8*--t*t*t*t),"easeInQuint"===e&&(n=t*t*t*t*t),"easeOutQuint"===e&&(n=1+--t*t*t*t*t),"easeInOutQuint"===e&&(n=.5>t?16*t*t*t*t*t:1+16*--t*t*t*t*t),n||t},m=function(e,t,n){var r=0;if(e.offsetParent)do r+=e.offsetTop,e=e.offsetParent;while(e);return r=Math.max(r-t-n,0),Math.min(r,p()-h())},h=function(){return Math.max(document.documentElement.clientHeight,window.innerHeight||0)},p=function(){return Math.max(e.document.body.scrollHeight,e.document.documentElement.scrollHeight,e.document.body.offsetHeight,e.document.documentElement.offsetHeight,e.document.body.clientHeight,e.document.documentElement.clientHeight)},g=function(e){return e&&"object"==typeof JSON&&"function"==typeof JSON.parse?JSON.parse(e):{}},b=function(t,n){e.history.pushState&&(n||"true"===n)&&"file:"!==e.location.protocol&&e.history.pushState(null,null,[e.location.protocol,"//",e.location.host,e.location.pathname,e.location.search,t].join(""))},v=function(e){return null===e?0:s(e)+e.offsetTop};c.animateScroll=function(n,c,u){var s=g(c?c.getAttribute("data-options"):null),f=l(t||i,u||{},s),h="[object Number]"===Object.prototype.toString.call(n)?!0:!1,y=h?null:"#"===n?e.document.documentElement:e.document.querySelector(n);if(h||y){var O=e.pageYOffset;r||(r=e.document.querySelector(f.selectorHeader)),o||(o=v(r));var S,I,H=h?n:m(y,o,parseInt(f.offset,10)),E=H-O,j=p(),w=0;h||b(n,f.updateURL);var C=function(t,r,o){var a=e.pageYOffset;(t==r||a==r||e.innerHeight+a>=j)&&(clearInterval(o),h||y.focus(),f.callback(n,c))},L=function(){w+=16,S=w/parseInt(f.speed,10),S=S>1?1:S,I=O+E*d(f.easing,S),e.scrollTo(0,Math.floor(I)),C(I,H,a)},A=function(){clearInterval(a),a=setInterval(L,16)};0===e.pageYOffset&&e.scrollTo(0,0),A()}};var y=function(e){if(0===e.button&&!e.metaKey&&!e.ctrlKey){var n=f(e.target,t.selector);if(n&&"a"===n.tagName.toLowerCase()){e.preventDefault();var r=c.escapeCharacters(n.hash);c.animateScroll(r,n,t)}}},O=function(e){n||(n=setTimeout(function(){n=null,o=v(r)},66))};return c.destroy=function(){t&&(e.document.removeEventListener("click",y,!1),e.removeEventListener("resize",O,!1),t=null,n=null,r=null,o=null,a=null)},c.init=function(n){u&&(c.destroy(),t=l(i,n||{}),r=e.document.querySelector(t.selectorHeader),o=v(r),e.document.addEventListener("click",y,!1),r&&e.addEventListener("resize",O,!1))},c});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.overunder = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var OVER = 'over';
	var UNDER = 'under';
	var BETWEEN = 'between';
	
	var isObj = function isObj(o) {
	  return o !== null && 'object' === (typeof o === 'undefined' ? 'undefined' : _typeof(o)) && !('nodeType' in o);
	};
	
	var merge = function merge(target) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  args.forEach(function (a) {
	    return Object.keys(a).forEach(function (k) {
	      return target[k] = a[k];
	    });
	  });
	  return target;
	};
	
	var addProps = function addProps(target, prop) {
	  isObj(prop) ? merge(target.options, prop) : target['range'] = prop;
	};
	
	var returnSize = function returnSize(el, type) {
	  var isWindow = el !== null && el.window ? true : false;
	
	  if (isWindow) {
	    return Math.max(el['outer' + type], document.documentElement['client' + type]);
	  }
	
	  return Math.max(el['offset' + type], el['client' + type]);
	};
	
	var returnScroll = function returnScroll() {
	  return window.scrollY || window.pageYOffset;
	};
	
	/**
	 * @param {string} type Either 'scroll' or 'resize'
	 * @param {object|number} delta First (required) threshold
	 * @param {...array} args Optional args
	 */
	var overunder = function overunder(type, delta) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  var ticking = false;
	  var isScroll = type === 'scroll' ? true : false;
	  var listeners = {};
	
	  var instance = Object.create({
	    init: function init() {
	      window.addEventListener(type, requestPosition);
	      if (this.options.watchResize) window.addEventListener('resize', requestPosition);
	      return this;
	    },
	    update: function update() {
	      var _this = this;
	
	      var delta = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	      if (delta) {
	        isObj(delta) ? addProps(this, delta) : this.delta = delta;
	      }
	
	      /**
	       * Add optional props to instance object
	       */
	
	      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        args[_key3 - 1] = arguments[_key3];
	      }
	
	      args.forEach(function (a) {
	        return !!a ? addProps(_this, a) : null;
	      });
	
	      requestPosition(true);
	    },
	    destroy: function destroy() {
	      window.removeEventListener(type, requestPosition);
	      window.removeEventListener('resize', requestPosition);
	    },
	    on: function on(e) {
	      var cb = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	      if (!cb) return;
	      listeners[e] = listeners[e] || { queue: [] };
	      listeners[e].queue.push(cb);
	    },
	    emit: function emit(e) {
	      var data = arguments.length <= 1 || arguments[1] === undefined ? undefined : arguments[1];
	
	      var items = listeners[e] ? listeners[e].queue : false;
	      items && items.forEach(function (i) {
	        return i(data);
	      });
	    }
	  }, {
	    delta: {
	      value: delta,
	      writable: true
	    },
	    options: {
	      value: {
	        context: window,
	        offset: 0,
	        negativeOffset: 0,
	        watchResize: false,
	        enterBottom: false
	      },
	      writable: true
	    }
	  });
	
	  /**
	   * Add optional props to instance object
	   */
	  args.forEach(function (a) {
	    return !!a ? addProps(instance, a) : null;
	  });
	
	  var currentPosition = returnPosition();
	
	  return instance;
	
	  function returnPosition() {
	    return isScroll ? returnScroll() : returnSize(instance.options.context, 'Width');
	  }
	
	  function requestPosition() {
	    var force = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    currentPosition = returnPosition();
	
	    if (!ticking) {
	      requestAnimationFrame(function () {
	        return checkPosition(force);
	      });
	      ticking = true;
	    }
	  }
	
	  /**
	   * @param {boolean} force Checks immediately
	   */
	  function checkPosition() {
	    var force = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    /**
	     * Check only once per call 
	     */
	    var checked = false;
	
	    /** 
	     * Viewport height
	     */
	    var viewport = window.innerHeight;
	
	    /**
	     * Cache or calculate delta and range
	     */
	    var delta = instance.delta;
	    var range = instance.range || false;
	    if ((typeof delta === 'undefined' ? 'undefined' : _typeof(delta)) === 'object') {
	      delta = isScroll ? delta.getBoundingClientRect().top + currentPosition : returnSize(delta, 'Width');
	    }
	    if ((typeof range === 'undefined' ? 'undefined' : _typeof(range)) === 'object') {
	      range = isScroll ? range.getBoundingClientRect().top + currentPosition : returnSize(range, 'Width') || false;
	    }
	
	    /**
	     * Offset values
	     */
	    var offset = instance.options.offset;
	    var negativeOffset = instance.options.negativeOffset;
	    if ((typeof negativeOffset === 'undefined' ? 'undefined' : _typeof(negativeOffset)) === 'object') {
	      negativeOffset = isScroll ? returnSize(negativeOffset, 'Height') : returnSize(negativeOffset, 'Width');
	    }
	    if ((typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) === 'object') {
	      offset = isScroll ? returnSize(offset, 'Height') : returnSize(offset, 'Width');
	    }
	
	    /**
	     * Calculate final delta and range values
	     */
	    delta = delta - offset + negativeOffset;
	    range = range ? range - offset + negativeOffset : false;
	
	    /**
	     * If enterBottom, subtract viewport
	     */
	    if (instance.options.enterBottom) {
	      delta = delta - viewport;
	
	      if (range) {
	        range = range - viewport;
	      }
	    }
	
	    /**
	     * Booleans
	     */
	    var notUnder = instance.position !== UNDER;
	    var notOver = instance.position !== OVER;
	    var notBetween = instance.position !== BETWEEN;
	
	    var underDelta = currentPosition < delta;
	    var overDelta = currentPosition >= delta;
	
	    var underRange = currentPosition < range;
	    var overRange = currentPosition >= range;
	
	    // Final booleans
	    var under = range ? underDelta && underRange && notUnder : underDelta && notUnder;
	    var over = range ? overDelta && overRange && notOver : overDelta && notOver;
	    var between = range ? overDelta && underRange && notBetween : false;
	
	    if (over) {
	      instance.position = OVER;
	      instance.emit(instance.position, instance);
	      checked = true;
	    } else if (under) {
	      instance.position = UNDER;
	      instance.emit(instance.position, instance);
	      checked = true;
	    } else if (between) {
	      instance.position = BETWEEN;
	      instance.emit(instance.position, instance);
	      checked = true;
	    }
	
	    if (force === true && !checked) {
	      if (underDelta) {
	        instance.position = UNDER;
	      } else if (range && overDelta && underRange) {
	        instance.position = BETWEEN;
	      } else if (range && overRange) {
	        instance.position = OVER;
	      } else if (!range && overDelta) {
	        instance.position = OVER;
	      }
	
	      instance.emit(instance.position, instance);
	    }
	
	    ticking = false;
	  }
	};
	
	exports.default = {
	  scroll: function scroll(delta, range, options) {
	    return overunder('scroll', delta, range, options);
	  },
	  resize: function resize(delta, range, options) {
	    return overunder('resize', delta, range, options);
	  }
	};
	
	},{}]},{},[1])(1)
	});

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// UMD module from From https://github.com/umdjs/umd/blob/master/returnExports.js
	// From 'if the module has no dependencies' example.
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.returnExports = factory();
	  }
	}(this, function () {
	// End of UMD module
	
		// Quick aliases and polyfills if needed
		var query = document.querySelector.bind(document);
		var queryAll = document.querySelectorAll.bind(document);
	
		var KEYCODES = {
			SPACE: 32,
			UP: 38,
			DOWN: 40,
			ENTER: 13
		};
	
		if ( ! NodeList.prototype.forEach ) {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}
		if ( ! HTMLCollection.prototype.forEach ) {
			HTMLCollection.prototype.forEach = Array.prototype.forEach;
		}
		if ( ! Element.prototype.matches ) {
			// See https://developer.mozilla.org/en-US/docs/Web/API/Element.matches
			Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.oMatchesSelector
		}
	
		// IE 9-11 CustomEvent polyfill
		// From https://developer.mozilla.org/en/docs/Web/API/CustomEvent
		var CustomEvent = function( eventName, params ) {
			params = params || { bubbles: false, cancelable: false, detail: undefined };
			var event = document.createEvent( 'CustomEvent' );
			event.initCustomEvent( eventName, params.bubbles, params.cancelable, params.detail );
			return event;
		};
		CustomEvent.prototype = window.Event.prototype;
		window.CustomEvent = CustomEvent;
	
		// IE10 dataset polyfill
		// From https://gist.githubusercontent.com/brettz9/4093766/raw/ba31a05e7ce21af67c6cafee9b3f439c86e95b01/html5-dataset.js
		if (!document.documentElement.dataset &&
				 // FF is empty while IE gives empty object
				(!Object.getOwnPropertyDescriptor(Element.prototype, 'dataset')  ||
				!Object.getOwnPropertyDescriptor(Element.prototype, 'dataset').get)
			) {
			var propDescriptor = {
				enumerable: true,
				get: function () {
					'use strict';
					var i,
						that = this,
						HTML5_DOMStringMap,
						attrVal, attrName, propName,
						attribute,
						attributes = this.attributes,
						attsLength = attributes.length,
						toUpperCase = function (n0) {
							return n0.charAt(1).toUpperCase();
						},
						getter = function () {
							return this;
						},
						setter = function (attrName, value) {
							return (typeof value !== 'undefined') ?
								this.setAttribute(attrName, value) :
								this.removeAttribute(attrName);
						};
					try { // Simulate DOMStringMap w/accessor support
						// Test setting accessor on normal object
						({}).__defineGetter__('test', function () {});
						HTML5_DOMStringMap = {};
					}
					catch (e1) { // Use a DOM object for IE8
						HTML5_DOMStringMap = document.createElement('div');
					}
					for (i = 0; i < attsLength; i++) {
						attribute = attributes[i];
						// Fix: This test really should allow any XML Name without
						//         colons (and non-uppercase for XHTML)
						if (attribute && attribute.name &&
							(/^data-\w[\w\-]*$/).test(attribute.name)) {
							attrVal = attribute.value;
							attrName = attribute.name;
							// Change to CamelCase
							propName = attrName.substr(5).replace(/-./g, toUpperCase);
							try {
								Object.defineProperty(HTML5_DOMStringMap, propName, {
									enumerable: this.enumerable,
									get: getter.bind(attrVal || ''),
									set: setter.bind(that, attrName)
								});
							}
							catch (e2) { // if accessors are not working
								HTML5_DOMStringMap[propName] = attrVal;
							}
						}
					}
					return HTML5_DOMStringMap;
				}
			};
			try {
				// FF enumerates over element's dataset, but not
				//   Element.prototype.dataset; IE9 iterates over both
				Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
			} catch (e) {
				propDescriptor.enumerable = false; // IE8 does not allow setting to true
				Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
			}
		}
	
		// Return true if any ancestor matches selector
		// Borrowed from ancestorMatches() from agave.js (MIT)
		var isAncestorOf = function(element, selector, includeSelf) {
			var parent = element.parentNode;
			if ( includeSelf && element.matches(selector) ) {
				return true
			}
			// While parents are 'element' type nodes
			// See https://developer.mozilla.org/en-US/docs/DOM/Node.nodeType
			while ( parent && parent.nodeType && parent.nodeType === 1 ) {
				if ( parent.matches(selector) ) {
					return true
				}
				parent = parent.parentNode;
			}
			return false;
		};
	
	
		// Used to match select boxes to their style select partners
		var makeUUID = function(){
			return 'ss-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/x/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
				return v.toString(16);
			})
		};
	
	
		// The 'styleSelect' main function
		// selector:String - CSS selector for the select box to style
		return function(selector) {
	
			// Use native selects (which pop up large native UIs to go through the options ) on iOS/Android
			if ( navigator.userAgent.match( /iPad|iPhone|Android/i ) ) {
				return
			}
	
			var realSelect = typeof selector == 'object' ? selector : query(selector),
				realOptions = realSelect.children,
				selectedIndex = realSelect.selectedIndex,
				uuid = makeUUID(),
				styleSelectHTML = '<div class="style-select" aria-hidden="true" data-ss-uuid="' + uuid + '">';
	
			// The index of the item that's being highlighted by the mouse or keyboard
			var highlightedOptionIndex;
			var highlightedOptionIndexMax = realOptions.length - 1;
	
			realSelect.setAttribute('data-ss-uuid', uuid);
			// Even though the element is display: none, a11y users should still see it.
			// According to http://www.w3.org/TR/wai-aria/states_and_properties#aria-hidden
			// some browsers may have bugs with this but future implementation may improve
			realSelect.setAttribute('aria-hidden', "false");
	
			// Build styled clones of all the real options
			var selectedOptionHTML;
			var optionsHTML = '<div class="ss-dropdown">';
			realOptions.forEach(function(realOption, index){
				var text = realOption.textContent,
					value = realOption.getAttribute('value') || '',
	                cssClass = 'ss-option';
	
				if (index === selectedIndex) {
					// Mark first item as selected-option - this is where we store state for the styled select box
					// aria-hidden=true so screen readers ignore the styles selext box in favor of the real one (which is visible by default)
					selectedOptionHTML = '<div class="ss-selected-option" tabindex="0" data-value="' + value + '">' + text + '</div>'
				}
	
	            if (realOption.disabled) {
	                cssClass += ' disabled';
	            }
	
	            // Continue building optionsHTML
				optionsHTML += '<div class="' + cssClass + '" data-value="' + value + '">' + text + '</div>';
			});
			optionsHTML += '</div>';
			styleSelectHTML += selectedOptionHTML += optionsHTML += '</div>';
			// And add out styled select just after the real select
			realSelect.insertAdjacentHTML('afterend', styleSelectHTML);
	
			var styledSelect = query('.style-select[data-ss-uuid="'+uuid+'"]');
			var styleSelectOptions = styledSelect.querySelectorAll('.ss-option');
			var selectedOption = styledSelect.querySelector('.ss-selected-option');
	
			var changeRealSelectBox = function(newValue, newLabel) {
				// Close styledSelect
				styledSelect.classList.remove('open');
	
				// Update styled value
				selectedOption.textContent = newLabel;
				selectedOption.dataset.value = newValue;
	
				// Update the 'tick' that shows the option with the current value
				styleSelectOptions.forEach(function(styleSelectOption){
					if ( styleSelectOption.dataset.value === newValue) {
						styleSelectOption.classList.add('ticked')
					} else {
						styleSelectOption.classList.remove('ticked')
					}
				});
	
				// Update real select box
				realSelect.value = newValue;
	
				// Send 'change' event to real select - to trigger any change event listeners
				var changeEvent = new CustomEvent('change');
				realSelect.dispatchEvent(changeEvent);
			};
	
			// Change real select box when a styled option is clicked
			styleSelectOptions.forEach(function(unused, index){
				var styleSelectOption = styleSelectOptions.item(index);
	
	            if (styleSelectOption.className.match(/\bdisabled\b/)) {
	                return;
	            }
	
	            styleSelectOption.addEventListener('click', function(ev) {
					var target = ev.target,
						styledSelectBox = target.parentNode.parentNode,
						uuid = styledSelectBox.getAttribute('data-ss-uuid'),
						newValue = target.getAttribute('data-value'),
						newLabel = target.textContent;
	
					changeRealSelectBox(newValue, newLabel)
	
				});
	
				// Tick and highlight the option that's currently in use
				if ( styleSelectOption.dataset.value === realSelect.value ) {
					highlightedOptionIndex = index;
					styleSelectOption.classList.add('ticked');
					styleSelectOption.classList.add('highlighted')
				}
	
				// Important: we can't use ':hover' as the keyboard and default value can also set the highlight
				styleSelectOption.addEventListener('mouseover', function(ev){
					styleSelectOption.parentNode.childNodes.forEach(function(sibling, index){
						if ( sibling === ev.target ) {
							sibling.classList.add('highlighted');
							highlightedOptionIndex = index;
						} else {
							sibling.classList.remove('highlighted')
						}
					})
				})
			});
	
	
	
			var closeAllStyleSelects = function(exception){
				queryAll('.style-select').forEach(function(styleSelectEl) {
					if ( styleSelectEl !== exception ) {
						styleSelectEl.classList.remove('open');
					}
				});
			};
	
			var toggleStyledSelect = function(styledSelectBox){
				if ( ! styledSelectBox.classList.contains('open') ) {
					// If we're closed and about to open, close other style selects on the page
					closeAllStyleSelects(styledSelectBox);
				}
				// Then toggle open/close
				styledSelectBox.classList.toggle('open');
			};
	
			// When a styled select box is clicked
			var styledSelectedOption = query('.style-select[data-ss-uuid="' + uuid + '"] .ss-selected-option');
			styledSelectedOption.addEventListener('click', function(ev) {
				ev.preventDefault();
				ev.stopPropagation();
				toggleStyledSelect(ev.target.parentNode);
			});
	
			// Keyboard handling
			styledSelectedOption.addEventListener('keydown', function(ev) {
				var styledSelectBox = ev.target.parentNode;
	
				switch (ev.keyCode) {
					case KEYCODES.SPACE:
						// Space shows and hides styles select boxes
						toggleStyledSelect(styledSelectBox);
						break;
					case KEYCODES.DOWN:
					case KEYCODES.UP:
						// Move the highlight up and down
						if ( ! styledSelectBox.classList.contains('open') ) {
							// If style select is not open, up/down should open it.
							toggleStyledSelect(styledSelectBox);
						} else {
							// If style select is already open, these should change what the highlighted option is
							if ( ev.keyCode === KEYCODES.UP ) {
								// Up arrow moves earlier in list
								if ( highlightedOptionIndex !== 0 ) {
									highlightedOptionIndex = highlightedOptionIndex - 1
								}
							} else {
								// Down arrow moves later in list
								if ( highlightedOptionIndex < highlightedOptionIndexMax ) {
									highlightedOptionIndex = highlightedOptionIndex + 1
								}
							}
							styleSelectOptions.forEach(function(option, index){
								if ( index === highlightedOptionIndex ) {
									option.classList.add('highlighted')
								} else {
									option.classList.remove('highlighted')
								}
							})
						}
						ev.preventDefault();
						ev.stopPropagation();
						break;
					// User has picked an item from the keyboard
					case KEYCODES.ENTER:
						var highlightedOption = styledSelectedOption.parentNode.querySelectorAll('.ss-option')[highlightedOptionIndex],
							newValue = highlightedOption.dataset.value,
							newLabel = highlightedOption.textContent;
	
						changeRealSelectBox(newValue, newLabel);
						ev.preventDefault();
						ev.stopPropagation();
						break;
				}
			});
	
			// Clicking outside of the styled select box closes any open styled select boxes
			query('body').addEventListener('click', function(ev){
	
				if ( ! isAncestorOf(ev.target, '.style-select', true) ) {
					closeAllStyleSelects();
				}
			})
	
		};
	
	// Close UMD module
	}));
	


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?t():"function"==typeof define&&define.amd?define(t):t()}(this,function(){"use strict";var e=function(e,t,n){switch(t){case"add":e.classList.add(n);break;case"remove":e.classList.remove(n);break;case"toggle":e.classList.toggle(n);break;default:console.log("invalid value for change option specified")}},t=function(t,n,o){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},a=i.change||"add",c=function(t){setTimeout(function(){e(t,a,n)},o)};t.length?[].forEach.call(t,function(e){c(e)}):c(t)};exports.lazy=t});


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _overunder = __webpack_require__(4);
	
	var _overunder2 = _interopRequireDefault(_overunder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stickyHidingTimeout = null;
	
	
	var Header = {
	  dom: {
	    header: document.querySelector('.header'),
	    smooth: document.querySelector('.smooth--navigation'),
	    headlines: document.querySelector('.js-headlines')
	  },
	  init: function init() {
	    this.handleNavigation(this.dom.header);
	    this.handleStickyNav(this.dom.header, this.dom.headlines);
	  },
	  handleStickyNav: function handleStickyNav(header, headlines) {
	    var _this = this;
	
	    var companyLink = document.querySelector('.js-company'),
	        companyBlock = document.getElementById('company'),
	        productBlock = document.getElementById('product'),
	        productLink = document.querySelector('.js-product'),
	        supplyBlock = document.getElementById('supply'),
	        supplyLink = document.querySelector('.js-supply'),
	        teamBlock = document.getElementById('team'),
	        teamLink = document.querySelector('.js-team'),
	        supplyMap = document.querySelector('.js-map'),
	        contactBlock = document.getElementById('contact'),
	        companyText = document.querySelector('.js-about-company'),
	        contactLink = document.querySelector('.js-contact');
	
	    var scroller = _overunder2.default.scroll(100, headlines, { watchResize: true, negativeOffset: 0 });
	    console.log('hey', scroller);
	    scroller.on('under', function (instance) {
	      // over endWaypoint offset top
	      _this.unselectAll();
	      header.classList.remove('sticky');
	    });
	    scroller.on('over', function (instance) {
	      // over endWaypoint offset top
	      header.classList.add('sticky');
	    });
	    scroller.init().update();
	
	    var companyScrollr = _overunder2.default.scroll(companyBlock, productBlock, { watchResize: true, offset: 60 });
	    companyScrollr.on('under', function (instance) {
	      _this.unselectAll();
	    });
	    companyScrollr.on('between', function (instance) {
	      _this.unselectAll();
	      companyLink.classList.add('active');
	    });
	
	    companyScrollr.init();
	
	    var companyTextScrollr = _overunder2.default.scroll(companyBlock, productBlock, { watchResize: true, offset: 400 });
	    companyTextScrollr.on('between', function (instance) {
	      companyText.classList.add('active');
	    });
	
	    companyTextScrollr.init();
	
	    var productShow = _overunder2.default.scroll(productBlock, supplyBlock, { watchResize: true, offset: 400 });
	    productShow.on('between', function (instance) {
	      var text = productBlock.querySelector('.text--wrapper');
	      text.classList.add('visible');
	    });
	    productShow.init();
	
	    var productScrollr = _overunder2.default.scroll(productBlock, supplyBlock, { watchResize: true, offset: 60 });
	    productScrollr.on('under', function (instance) {
	      _this.unselectAll();
	      companyLink.classList.add('active');
	    });
	    productScrollr.on('between', function (instance) {
	      _this.unselectAll();
	      productLink.classList.add('active');
	    });
	    productScrollr.init();
	
	    var supplyText = _overunder2.default.scroll(supplyBlock, teamBlock, { watchResize: true, offset: 400 });
	
	    supplyText.on('between', function (instance) {
	      var text = supplyBlock.querySelector('.text--wrapper');
	      text.classList.add('visible');
	    });
	    supplyText.init();
	
	    var supplyMapS = _overunder2.default.scroll(supplyMap, teamBlock, { watchResize: true, offset: 600 });
	
	    supplyMapS.on('between', function (instance) {
	      supplyMap.classList.add('active');
	    });
	    supplyMapS.init();
	
	    var supplyScrollr = _overunder2.default.scroll(supplyBlock, teamBlock, { watchResize: true, offset: 60 });
	    supplyScrollr.on('under', function (instance) {
	      _this.unselectAll();
	      productLink.classList.add('active');
	    });
	    supplyScrollr.on('between', function (instance) {
	      _this.unselectAll();
	      supplyLink.classList.add('active');
	    });
	    supplyScrollr.init();
	
	    var teamScrollr = _overunder2.default.scroll(teamBlock, contactBlock, { watchResize: true, offset: 60 });
	    teamScrollr.on('under', function (instance) {
	      _this.unselectAll();
	      supplyLink.classList.add('active');
	    });
	    teamScrollr.on('between', function (instance) {
	      _this.unselectAll();
	      teamLink.classList.add('active');
	    });
	    teamScrollr.on('over', function (instance) {
	      _this.unselectAll();
	      contactLink.classList.add('active');
	    });
	    teamScrollr.init();
	
	    var heroScrollr = _overunder2.default.scroll(0, companyBlock, { watchResize: true, offset: 60 });
	    heroScrollr.on('under', function (instance) {
	      _this.unselectAll();
	    });
	    heroScrollr.on('between', function (instance) {
	      _this.unselectAll();
	    });
	
	    heroScrollr.init();
	  },
	  unselectAll: function unselectAll() {
	    var nav = document.querySelectorAll('.nav-link');
	    [].forEach.call(nav, function (item) {
	      item.classList.remove('active');
	    });
	  },
	  handleNavigation: function handleNavigation(header) {
	    var toggle = header.querySelector('.js-toggle-nav');
	
	    // Only apply the transition style to the mobile navigation
	    // while it's opening to prevent the resize flicker
	
	    toggle.addEventListener('click', function () {
	      if (header.classList.contains('opening')) {
	
	        header.classList.remove('open');
	        setTimeout(function () {
	          header.classList.remove('opening');
	        }, 250);
	      } else {
	        header.classList.add('opening');
	
	        // open after we apply a transition class
	        setTimeout(function () {
	          header.classList.add('open');
	        }, 100);
	      }
	    });
	
	    this.resizeUnClass(header);
	  },
	  resizeUnClass: function resizeUnClass(header) {
	    // Remove classes applied to search/navigation/mobile
	    window.addEventListener('resize', function (event) {
	      header.classList.remove('open');
	    });
	  }
	};
	
	exports.default = Header;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/